<div class="bgPhoto d-flex align-items-center justify-content-center">
  <div class="text-center">
    <p class="titles">البحث فى خريطة الاستثمار</p>
    <button class="btnGreen">بحث</button>
  </div>
</div>

<section class="invest-video square start-square">
  <!-- صورة الـ thumbnail -->
  <div class="thumbnail-wrapper" id="video-thumbnail">
    <img src="../../../assets/footer.png" alt="Video Thumbnail" class="thumbnail-img" />
    <div class="image-overlay" id="play-video">
      <span class="icon-playbtn"></span>
    </div>
  </div>

  <iframe id="video" width="100%" height="451" src="" frameborder="0" allowfullscreen style="display: none;"></iframe>
</section>